import { assign, findIndex, remove } from "lodash";
import * as types from "../actions/ActionTypes";
import { Dictionary } from "../types/Dictionary";

export type FastTrackStatuses = "working" | "suspended";

export interface FormState {
	initialEntity: any;
	form: any;
	forms: Array<any>;
	flows?: any;
	directions?: any;
	process: {
		all: Array<any>;
	};
	mentors: {
		slave: Array<any>;
	};
	mode: FastTrackStatuses;
	modeLoaded: boolean;
	loaders: any;
	values: Array<any>;
	section: string;
	listUserForms: Array<any>;
	checkedPanel: Array<string>;
	user: any;
	companies: Array<any>;
	countToSend: number;
	errors: Dictionary<any | undefined>;
	visited: Dictionary<boolean>;
	allVisited: boolean;
	readonly?: boolean;
	status?: number;
	formUid?: string;
	process_id?: number;
	form_type?: string;
	process_stage?: number;
	mentor_confirmed?: boolean;
	countries?: Array<any>;
	control_mode?: any;
	allow_defence?: boolean;
	appointedStatus?: "appointed" | "confirmed" | "refused";
	dynamicOptions?: Record<string, Array<any>>;
}

const defaultState: FormState = {
	initialEntity: {},
	form: {},
	forms: [],
	process: {
		all: [],
	},
	mentors: {
		slave: [],
	},
	mode: "suspended",
	modeLoaded: false,
	loaders: {},
	values: [],
	section: "1",
	listUserForms: [],
	checkedPanel: [],
	user: {},
	companies: [],
	countToSend: 0,
	errors: {},
	visited: {},
	allVisited: false,
	process_id: 0,
	flows: [],
	directions: [],
	countries: [],
	control_mode: {},
};

export interface Action {
	type: string;
	payload: any;
}

function updateControls(controls: any[], updater: (control: any) => void) {
	return controls.map((c) => {
		if (c.controls) {
			c = { ...c, controls: updateControls(c.controls, updater) };
		}

		return updater(c);
	});
}

// function updateStateControls(state: any, updater: (control: any) => void) {
// 	const newForm = {
// 		...state.form,
// 		sections: state.form.sections.map((s) => ({
// 			...s,
// 			controls: updateControls(s.controls, updater),
// 		})),
// 	};
// 	return { ...state, form: newForm };
// }

// autocomplete() {
//     let { schema: {extra, value} } = this.props;
//
//     if (typeof value === 'undefined' && typeof extra !== 'undefined' && typeof extra.init !== 'undefined') {
//         console.log('autocomplete', value, extra);
//         if (extra.init === 'set_full_contact') {
//             if (typeof SK !== 'undefined') {
//                 const { first_name, last_name, middle_name, phone, email } = SK.user();
//                 value = `${last_name || ''} ${first_name || ''} ${middle_name || ''}`.trim();
//                 value = phone ? `${value}, ${phone}` : value;
//                 value = email ? `${value}, ${email}` : value;
//                 if (value.length > 0) {
//                     this.props.schema.disabled = true;
//                 }
//                 this.props.schema.value = value;
//                 this.setState({ value });
//             }
//         }
//     }
//     // return value
// }

export function forms(state: FormState = defaultState, action: Action) {
	switch (action.type) {
		case types.LOADING_START:
			state.loaders[action.payload] = true;
			return assign({}, state, { loaders: { ...state.loaders } });
		case types.LOADING_FINISH:
			delete state.loaders[action.payload];
			return assign({}, state, { loaders: { ...state.loaders } });
		case types.FETCH_FORM:
			return assign({}, state, {
				form: action.payload,
				errors: {},
				visited: {},
				allVisited: false,
			});
		case types.FETCH_FORMS:
			return assign({}, state, { forms: action.payload });
		case types.FETCH_COMPANIES:
			return assign({}, state, { companies: action.payload.data || [] });
		case types.FETCH_MM_PROCESS:
			return assign({}, state, { process: { all: action.payload || [] } });
		case types.FETCH_MENTOR_PROCESS:
			return assign({}, state, { process: { all: action.payload || [] } });
		case types.SET_MENTOR:
			return assign({}, state, {
				process: {
					all: state.process.all.map((proc) => {
						if (Number(proc.process_id) === Number(action.payload.process_id)) {
							return { ...proc, mentor_email: action.payload.mentor };
						}
						return undefined;
					}),
				},
			});
		case types.FETCH_SLAVE_MENTORS:
			return assign({}, state, { mentors: { slave: action.payload || [] } });
		case types.FETCH_SETTINGS: {
			if (typeof action.payload.suspended !== "undefined") {
				const formMode = action.payload.suspended ? "suspended" : "working";

				return assign({}, state, { mode: formMode });
			}
			return state;
		}
		case types.FETCH_SETTINGS_FINISHED: {
			return assign({}, state, { modeLoaded: true });
		}
		case types.GET_FLOWS: {
			if (Array.isArray(action.payload)) {
				return assign({}, state, { flows: action.payload });
			}
			return state;
		}
		case types.GET_DIRECTIONS: {
			if (Array.isArray(action.payload)) {
				return assign({}, state, { directions: action.payload });
			}
			return state;
		}
		case types.ADD_VALUE: {
			const stamp = +new Date();
			const valuesLookUp: { [key: string]: any } = {};
			action.payload.forEach((p) => {
				valuesLookUp[p.controlid] = p.value;
			});
			const newForm = {
				...state.form,
				sections: state.form.sections
					? state.form.sections.map((s) => ({
							...s,
							$$timestamp: stamp,
							controls: updateControls(s.controls, (c) => ({
								...c,
								value: valuesLookUp[c.id],
							})),
					  }))
					: [],
			};
			return assign({}, state, { values: [...action.payload], form: newForm });
		}
		case types.SET_SECTION:
			return assign({}, state, { section: action.payload.id });
		case types.SET_FORM_UID:
			return assign({}, state, { formUid: action.payload });
		case types.CLEAR_VALUES:
			return assign({}, state, {
				values: [],
				form: {},
				readonly: undefined,
				errors: {},
				visited: {},
				allVisited: false,
			});
		case types.FETCH_VALUES:
			return assign({}, state, { listUserForms: action.payload });
		case types.SET_NEW_PROCESS_ID:
			return assign({}, state, {
				process_id: action.payload.process_id,
				form_type: action.payload.form_type,
			});
		case types.OPEN_FORM: {
			const valuesLookUp: { [key: string]: any } = {};
			action.payload.values.forEach((p) => {
				valuesLookUp[p.controlid] = p.value;
			});
			action.payload.form = {
				...action.payload.form,
				sections: action.payload.form.sections.map((s) => ({
					...s,
					controls: updateControls(s.controls, (c) => ({
						...c,
						value: valuesLookUp[c.id] || c.value,
					})),
				})),
			};

			return assign({}, state, {
				...action.payload,
				errors: {},
				visited: {},
				allVisited: false,
			});
		}

		case types.CHECKED_PANEL:
			return action.payload.checked
				? assign({}, state, {
						checkedPanel: [...state.checkedPanel, action.payload.panelId],
				  })
				: assign({}, state, {
						checkedPanel: remove(state.checkedPanel, (id) => id !== action.payload.panelId),
				  });
		case types.AUTH_USER_SUCCESS:
			return assign({}, state, { user: action.payload });
		case types.ATTEMPT_TO_SEND:
			return assign({}, state, { countToSend: action.payload });
		case types.SET_STATUS_DEFAULT:
			return assign({}, state, { status: action.payload });
		case types.CREATE_REQUEST_BEFORE:
			return assign({}, state, { checkedPanel: [] });
		case types.REQUEST_UNCHEK_UPDATE:
			const requests = [...state.listUserForms];
			const idx = findIndex(
				requests,
				(obj) => obj.formId === action.payload.formId && obj.valuesId === action.payload.valuesId
			);
			if (idx > -1) {
				requests[idx].updateState = "";
			}
			return assign({}, state, { listUserForms: requests });
		case types.MARK_VISITED: {
			if (!state[action.payload]) {
				return {
					...state,
					visited: { ...state.visited, [action.payload]: true },
				};
			}
			return state;
		}
		case types.SET_ERROR: {
			if (state.errors[action.payload.id] !== action.payload.error) {
				return {
					...state,
					errors: {
						...state.errors,
						[action.payload.id]: action.payload.error,
					},
				};
			}
			return state;
		}
		case types.MARK_ALL_VISITED: {
			return { ...state, errors: {}, allVisited: true };
		}
		case types.SET_INITIAL_ENTITY: {
			return { ...state, initialEntity: action.payload.initialEntity };
		}
		case types.GET_COUNTRIES: {
			return { ...state, countries: [...action.payload] };
		}
		case types.SET_DYNAMIC_OPTIONS: {
			return {
				...state,
				dynamicOptions: {
					...state.dynamicOptions,
					[action.payload.selectType]: action.payload.options,
				},
			};
		}
		case types.FETCH_HISTORY: {
			return {
				...state,
				history: [],
			};
		}
		case types.SET_HISTORY: {
			return {
				...state,
				history: [...action.payload],
			};
		}
		case types.GET_APPOINTED_STATUS: {
			return {
				...state,
				appointedStatus: action.payload,
			};
		}
		case types.REMOVE_MENTOR_ROW: {
			return {
				...state,
				process: {
					...state.process,
					all: action.payload,
				},
			};
		}
		default:
			return state;
	}
}
